import { Project } from 'lib/types/projects';
import { PortfolioCard } from 'components/PortfolioCard';
import { useApi } from 'lib/contexts/ApplicationState';
import { useState, useEffect, useRef } from 'react';
import { MobileTooltip } from 'components/MobileTooltip';

export const ProjectsModule = () => {
  const API = useApi();
  const [projects, setProjects] = useState<Project[] | undefined>();
  const hasFetched = useRef(false);

  useEffect(() => {
    const getProjects = async () => {
      try {
        const response = await API.getFeaturedProjectsForHome();

        if (response.length) {
          const projectIds = response.map((project) => project.id);
          const projectsWithStats = await Promise.all(projectIds.map(async (projectId) => {
            const statsResponse = await API.getProjectPostStats(projectId);
            return {
              ...response.find((project) => project.id === projectId),
              stats: statsResponse.stats,
            };
          }));
          setProjects(projectsWithStats as Project[]);
        }
      } catch (err) {
        // noop
      }
    };

    if (API && !hasFetched.current) {
      hasFetched.current = true;
      getProjects();
    }
  }, [API]);

  if (!projects || !projects.length) {
    return null;
  }

  return (
    <div className="max-w-screen-xl m-auto p-4">
      <div className="flex mb-2 flex-wrap gap-2 items-center">
        <h3 className="font-extrabold text-2xl mb-1" suppressHydrationWarning>
          Featured Projects On Gondola
        </h3>
        <MobileTooltip
          title="Your featured project might show up on the homepage!"
        >
          <span className="cursor-default text-xs font-semibold inline-block py-1 px-2 rounded-full bg-teal uppercase">
            Beta
          </span>
        </MobileTooltip>
      </div>
      <div className="grid grid-flow-row grid-cols-1 sm:grid-cols-2 gap-6">
        {projects.map((project: Project) => (
          <PortfolioCard
            project={project}
            key={project.id}
            showUsername
          />
        ))}
      </div>
    </div>
  );
};
